var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 96,
    viewBox: "0 0 83 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1798_22695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0364 50.4348H54.0592",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3608 50.4348H65.3761",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9624 50.4348H47.9853",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99174 45.2983H22.4173C22.9051 45.2983 23.3471 45.5727 23.5605 46.0071L25.4123 49.7261C25.6257 50.1605 26.0677 50.4348 26.5554 50.4348H66.344C67.0527 50.4348 67.6167 51.0064 67.6167 51.7075V95.7103H0.469238V47.8208C0.469238 46.4262 1.59713 45.2983 2.99174 45.2983Z",
    fill: "#C1E8FF",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8363 59.7551H13.3943C12.8532 59.7551 12.3731 60.0981 12.1902 60.601L1.07135 94.0033C0.774133 94.834 1.39142 95.7104 2.27544 95.7104H66.7175C67.2585 95.7104 67.7386 95.3674 67.9216 94.8644L79.0404 61.4622C79.3376 60.6315 78.7203 59.7551 77.8363 59.7551Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1283 23.6704L80.0767 25.4613",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5917 26.734L80.6179 26.5815",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0115 26.7035C78.0115 25.9261 75.5347 23.7313 73.6371 23.6018C71.7319 23.4646 70.3754 24.4172 70.2839 25.728C70.1925 27.0388 71.3966 28.1895 73.2942 28.3038C75.4737 28.4334 78.0115 27.3741 78.0115 26.7111V26.7035Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3848 27.5189C77.638 27.2979 75.3441 28.9363 74.6811 30.7196C74.018 32.5029 74.5439 34.0804 75.7785 34.5377C77.013 34.9949 78.4534 34.1642 79.0935 32.3733C79.8328 30.3157 79.0173 27.7094 78.3848 27.5265V27.5189Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4154 27.0768C77.9124 26.2918 75.4356 26.5586 74.0105 27.2216C72.5854 27.8846 71.9834 29.1192 72.4482 30.1023C72.9131 31.0854 74.2391 31.4283 75.6566 30.75C77.2799 29.9651 78.926 27.8694 78.423 27.0768H78.4154Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3909 27.976C80.1527 27.976 80.7702 27.3585 80.7702 26.5967C80.7702 25.8349 80.1527 25.2173 79.3909 25.2173C78.629 25.2173 78.0115 25.8349 78.0115 26.5967C78.0115 27.3585 78.629 27.976 79.3909 27.976Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8421 31.1083C69.8421 31.1083 64.3856 35.9094 58.2279 33.0744C53.5258 30.9101 46.0574 28.822 42.3918 36.0466C38.5127 43.6903 45.7297 48.56 51.2243 46.0299C54.5013 44.521 55.5149 37.3878 49.1134 37.2964C45.5925 37.243 34.7633 43.4617 37.3315 59.7246",
    stroke: "#1F2025",
    strokeWidth: 0.47,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1798_22695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.6406,
    height: 96,
    fill: "white",
    transform: "translate(0.179688)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.27f4ed9d8c10dab2841f78c81a9be262.svg";
export { ForwardRef as ReactComponent };